import { render, staticRenderFns } from "./YiXinApplicationPreview.vue?vue&type=template&id=53af8c70&"
import script from "./YiXinApplicationPreview.vue?vue&type=script&lang=js&"
export * from "./YiXinApplicationPreview.vue?vue&type=script&lang=js&"
import style0 from "./YiXinApplicationPreview.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports